export const INVESTOR_BLUE = 'rgb(37 99 235)';
export const FLIPPEX_PINK = 'rgb(215 57 134)';

export const money = (value, { currency = 'EUR', decimals = 0, signed = false } = {}) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  const n = Number(value);
  const formatted = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(Math.abs(n));
  if (!signed) return n < 0 ? `-${formatted}` : formatted;
  return `${n >= 0 ? '+' : '-'}${formatted}`;
};

export const pct = (value, { signed = false, decimals = 1 } = {}) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  const n = Number(value);
  return `${signed && n >= 0 ? '+' : ''}${n.toFixed(decimals)}%`;
};

export const shortDate = (iso) => {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
};

export const relativeDay = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const diff = Math.floor((new Date().setHours(0, 0, 0, 0) - new Date(d).setHours(0, 0, 0, 0)) / 86400000);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Yesterday';
  if (diff < 7) return `${diff} days ago`;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
};

export const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 18) return 'Good afternoon';
  return 'Good evening';
};

export const changeColor = (value) => {
  const n = Number(value || 0);
  if (n > 0) return 'text-emerald-600';
  if (n < 0) return 'text-red-600';
  return 'text-foreground-muted';
};
